<template>
  <div class="fill-height">
    <v-layout row>
      <v-flex class="xs10">
        <div class="title mt-3 pl-2">{{ $t('titleSatisfactionSurvey') | cap }}</div>
      </v-flex>
      <v-flex class="xs2">
        <v-btn icon @click="cancel()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-stepper v-model="step" vertical>
      <v-stepper-step step="1" :complete="step > 1">{{ $t('titleAgentSatisfaction1') }}</v-stepper-step>
      <v-stepper-content step="1" class="pa-2">
        <v-card flat height="300px">
          <v-subheader class="mt-1">
            {{ $t('questionAgentSatisfaction1') }}
          </v-subheader>
          <v-radio-group v-model="satisfaction">
            <v-layout>
              <v-icon>mood</v-icon>
              <v-radio
                color="primary"
                :value="5"
                :label="$t('verySatisfying')"
              ></v-radio>
            </v-layout>
            <v-layout>
              <v-icon>sentiment_satisfied</v-icon>
              <v-radio
                color="primary"
                :value="4"
                :label="$t('satisfying')"
              ></v-radio>
            </v-layout>
            <v-layout>
              <v-icon>sentiment_neutral</v-icon>
              <v-radio
                color="primary"
                :value="3"
                :label="$t('sentimentNeutral')"
              ></v-radio>
            </v-layout>
            <v-layout>
              <v-icon>sentiment_dissatisfied</v-icon>
              <v-radio
                color="primary"
                :value="2"
                :label="$t('ratherUnsatisfying')"
              ></v-radio>
            </v-layout>
            <v-layout>
              <v-icon>mood_bad</v-icon>
              <v-radio
                color="primary"
                :value="1"
                :label="$t('veryUnsatisfying')"
              ></v-radio>
            </v-layout>
          </v-radio-group>
        </v-card>
        <v-btn color="primary" @click="nextStep()" :disabled="!satisfaction">{{ $t('next') }}</v-btn>
      </v-stepper-content>
      <v-stepper-step step="2" :complete="step > 2">{{ $t('titleAgentSatisfaction2') }}</v-stepper-step>
      <v-stepper-content step="2" class="pa-2">
        <v-card flat height="300px">
          <v-subheader class="mt-1">
            {{ $t('questionAgentSatisfaction2') + ' ' + $t('iPrefer') }}
          </v-subheader>
          <v-radio-group v-model="version">
            <v-radio
              v-for="i in 6"
              :key="i"
              color="primary"
              :value="6 - i + 1"
              :label="$t('version' + (6 - i))"
            ></v-radio>
          </v-radio-group>
        </v-card>
        <v-btn flat @click="previousStep()">{{ $t('previous') }}</v-btn>
        <v-btn color="primary" @click="nextStep()" :disabled="version == null">{{ $t('next') }}</v-btn>
      </v-stepper-content>
      <v-stepper-step step="3">{{ $t('titleAgentSatisfaction3') }}</v-stepper-step>
      <v-stepper-content step="3" class="pa-2">
        <v-card flat height="300px">
          <v-subheader class="mt-1">
            {{ $t('questionAgentSatisfaction3') }}
          </v-subheader>
          <v-text-field
            v-model="details"
            :label="$t('scenarioComment')"
            multi-line
            single-line
            class="textarea-satisfaction"
          ></v-text-field>
        </v-card>
        <v-btn flat @click="previousStep()">{{ $t('previous') }}</v-btn>
        <v-btn color="primary" @click="submit()">{{ $t('submit') }}<v-icon right>send</v-icon></v-btn>
      </v-stepper-content>
    </v-stepper>
    <v-footer absolute class="white">
      <v-layout class="row">
        <v-flex class="xs1">
          <v-checkbox
            v-model="stopDisplaySurvey"
            color="primary"
          ></v-checkbox>
        </v-flex>
        <v-flex class="xs11">
          <small>Ne plus me proposer le questionnaire</small>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    opened: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      surveyId: 0,
      // étape du questionnaire
      step: 0,
      // indice de satisfaction où null indique pas réponse
      satisfaction: null,
      // indice de préférence de version où null indique pas réponse
      version: null,
      // Informations complémentaire à l'enquête
      details: '',
      // Ne plus afficher le questionnaire pour cet agent
      stopDisplaySurvey: false
    }
  },

  computed: {
    ...mapState('_User', ['id'])
  },

  mounted () {
    setTimeout(() => {
      this.getSurvey().then(res => {
        this.surveyId = res.data.SURVEY_ID
        this.satisfaction = res.data.SURVEY_SATISFACTION
        this.version = res.data.SURVEY_VERSION_PREF
        this.details = res.data.SURVEY_DETAILS
        this.stopDisplaySurvey = res.data.SURVEY_STOP || true
        if (!this.stopDisplaySurvey) {
          this.$emit('update:opened', true)
        }
      })
    }, 1000 * 60 * 2) // 2 minutes
  },

  methods: {
    ...mapActions('_Notifier', ['NEW_NOTIF']),
    cancel () {
      // l'agent ne veut plus voir le questionnaire
      this.saveSurvey()
      this.$emit('update:opened', false)
    },
    submit () {
      this.$emit('update:opened', false)
      this.stopDisplaySurvey = true
      this.saveSurvey().then(() => {
        this.NEW_NOTIF({
          message: this.$t('thanksParticipation'),
          context: 'success'
        })
      })
    },
    previousStep () {
      this.step--
    },
    nextStep () {
      this.step++
      this.saveSurvey().then(res => {
        this.surveyId = res.data.id
      })
    },
    getSurvey () {
      return new Promise((resolve, reject) => {
        this.axios
          .get('get/satisfaction_agent.php?id=' + this.id)
          .then(res => {
            resolve(res)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    saveSurvey () {
      let dataToPost = new window.FormData()
      dataToPost.append('id', this.surveyId)
      dataToPost.append('userId', this.id)
      dataToPost.append('satisfaction', this.satisfaction)
      dataToPost.append('version', this.version)
      dataToPost.append('details', this.details)
      dataToPost.append('stopDisplaySurvey', this.stopDisplaySurvey)
      let method = this.surveyId ? 'put' : 'post'
      return new Promise((resolve, reject) => {
        this.axios
          .post(method + '/satisfaction_agent.php', dataToPost, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(res => {
            resolve(res)
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  }
}
</script>

<style scoped>
.stepper {
  box-shadow: none;
}
.textarea-satisfaction {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSatisfactionAgent.vue